module.exports = __webpack_public_path__ + "static/media/191CS165.06aa1a9d.jpg";